import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { wrapper, hidden, bubblePortal, bubbleHidden } from "./styles_vanilla.css";

type Props = {
  message: string;
  children: React.ReactNode;
};

const DisabledConclusionTooltip: React.FC<Props> = ({ message, children }) => {
  const [hover, setHover] = useState(false);
  const [coords, setCoords] = useState<{ top: number; left: number } | null>(null);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!hover) return;
    const update = () => {
      const wrapperEl = ref.current;
      if (!wrapperEl) return;
      const optionEl = wrapperEl.closest('[role="option"]');
      const rect = (optionEl ?? wrapperEl).getBoundingClientRect();
      setCoords({ top: rect.top, left: rect.left + rect.width / 2 });
    };
    update();
    window.addEventListener("scroll", update, true);
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update, true);
      window.removeEventListener("resize", update);
    };
  }, [hover]);
  return (
    <div
      ref={ref}
      className={wrapper}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {children}
      {hover && coords
        ? createPortal(
            <div
              className={bubblePortal}
              style={{
                top: coords.top,
                left: coords.left,
                transform: "translate(-50%, calc(-100% - 8px))",
              }}
              role="tooltip"
            >
              {message}
            </div>,
            document.body,
          )
        : null}
      <div aria-hidden="true" className={hover ? bubbleHidden : hidden}>
        {message}
      </div>
    </div>
  );
};

export default DisabledConclusionTooltip;
